import { BoxProps } from '@chakra-ui/react';
import { MotionBox } from '@sphere/ui';
import { PropsWithChildren } from 'react';

export const StaggeredItem = ({ children, ...props }: PropsWithChildren<BoxProps>) => (
  <MotionBox
    variants={{
      hidden: { opacity: 0, translateX: '-80px' },
      show: { opacity: 1, translateX: 0 },
    }}
    transition={{
      duration: 0.4,
      ease: [0, 0, 0.1, 1],
      opacity: {
        duration: 0.5,
        ease: [0.25, 1, 0.25, 1],
      },
    }}
    {...props}
  >
    {children}
  </MotionBox>
);
